export default [
  {
    path: "/reports-old",
    name: "reports",
    redirect: "/reports/documents",
    // component: () => import("@/app/reports/pages/ReportsPage"),
    // meta: {
    //   requiresAuth: true,
    // },
  },
];
